import form from './formStore'
import outform from './outFormStore'

export default {
  namespaced: true,
  modules: {
    form,
    outform
  }
}
